import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Dropdown, Spinner, Image } from 'react-bootstrap';

const Profile: React.FC = () => {
  const {
    isAuthenticated,
    isLoading,
    user,
    loginWithRedirect,
    logout,
  } = useAuth0();

  const [showDropdown, setShowDropdown] = useState(false);

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />;
  }

  if (!isAuthenticated) {
    return (
      <Button variant="primary" onClick={() => loginWithRedirect({
          appState: { returnTo: window.location.pathname }
        })}>
        <i className="bi bi-box-arrow-in-right me-2" />
        Log in
      </Button>
    );
  }

  return (
    <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
      <Dropdown.Toggle as="div" style={{ cursor: 'pointer' }}>
        <Image
          src={user?.picture || 'https://via.placeholder.com/40'}
          roundedCircle
          width={40}
          height={40}
          alt="User avatar"
        />
      </Dropdown.Toggle>

      <Dropdown.Menu align="start">
        <Dropdown.Header>
          <strong>{user?.name}</strong>
        </Dropdown.Header>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={() =>
            logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
            })
          }
        >
          <i className="bi bi-box-arrow-right me-2" />
          Log out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Profile;
